
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#1C2732","stroke-width":"1.326","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M2.383 5.697a1.989 1.989 0 103.977 0 1.989 1.989 0 00-3.977 0zM4.371 9.011a3.314 3.314 0 00-3.314 3.315v1.988h1.326l.662 5.303h2.652M15.64 5.697a1.989 1.989 0 103.977 0 1.989 1.989 0 00-3.977 0zM17.629 9.011a3.314 3.314 0 013.314 3.315v1.988h-1.326l-.662 5.303h-2.652M8.348 3.708a2.652 2.652 0 105.304 0 2.652 2.652 0 00-5.304 0zM15.64 12.326a4.64 4.64 0 10-9.28 0v1.988h1.988l.663 6.63h3.978l.663-6.63h1.988v-1.988z"}})])])
          )
        }
      }
    